<template>
  <div class="one-answer mb-4">
    <!-- <div
      v-if="question.hasRanges"
      class="d-flex justify-content-center align-items-center"
    >
      <span class="tag-value fs-3">
        {{ $tr(question.messages, 'ranges')[question.value] }}
      </span>
    </div> -->
    <div class="d-flex justify-content-center align-items-center">
      <div
        class="value-background-color single-value-box d-flex justify-content-center align-items-center"
      >
        <span v-if="question.type === 'zeroToTen'" class="tag-value">
          {{ question.value }}
        </span>
        <span v-if="question.type === 'yesOrNo'" class="tag-value">
          {{ yesOrNoValue.label }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { valueColorForQuestion } from '@/components/shared/charts/chart-helpers'

export default {
  name: 'IndividualGroupAnswer',
  props: {
    question: {
      type: Object,
      default: () => {}
    },
    yesOrNoValue: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    colorForValue() {
      return valueColorForQuestion(this.question, this.yesOrNoValue?.value)
    }
  }
}
</script>

<style lang="scss" scoped>
.value-background-color {
  background: v-bind(colorForValue);
}
.single-value-box {
  height: 50px;
  width: 50px;
  border-radius: 15%;
}
</style>
